export default [
 {
    id: "comake",
    title: "Co-Make",
    date: "July 2019",
    summary: " Co-Make is an application designed to project citizens’ voices within their local communities by providing them the ability to post issues or concerns within their communities that they would like to see addressed by their local governments.  Once an issue or concern is posted, fellow citizens would be able to upvote the ones they’d like to see addressed--essentially creating a prioritized list of actions for local governments created by its constituents.",
    role: "Front end engineer",
    highlights: [
     "Worked with a UX design team and built a responsive UI with React according to UX specifications",
     "Delivered features such as creating community concerns, upvoting of previously posted concerns, and ability to leave comments"
    ],
    link: "https://github.com/tjvonbr/personal_comake_fe",
    deployed: "https://comake-fe.herokuapp.com/"
  },

  {
    id: "wanderlust",
    title: "Wanderlust",
    date: "August 2019",
    summary: "Wanderlust is an application that offers pre-packaged vacations to potential clients.  Instead of having to worry about planning out the vacation hour-by-hour, day-by-day, clients can outsource that task to Wanderlust and focus on the reason to take a vacation in the first place.",
    role: "Front end engineer",
    highlights: [
      "Designed and built a responsive and engaging UI with React",
      "Offers features such as adding vacations to a ‘favorites’ list and leaving reviews of vacations that the user has personally experienced",
      "Streamlined state management using Redux"
    ],
    link: "https://github.com/tjvonbr/personal_wanderlust_fe",
    deployed: "https://wanderlust-endorsement.herokuapp.com/"
  },

  {
    id: "splitthebill",
    title: "Split the Bill",
    date: "September 2019",
    summary: "Split the Bill gives restaurant-goers the ability to split the bill evenly amongst themselves.  Instead of everyone having to offer their cards or count cash at the table, one person can pay for the meal, and request the evenly distributed amount from the rest of the table!",
    role: "Back end engineer",
    highlights: [
      "Pair-programmed a RESTful API to facilitate data transfer between server and client",
      "Implemented security measures including JSON web tokens and user session technologies to ensure client protection"
    ],
    link: "https://github.com/tjvonbr/personal_split_the_bill_fe",
    deployed: "https://split-the-bill-fe.herokuapp.com/"
  }
]